import { render, staticRenderFns } from "./AddDependents.vue?vue&type=template&id=679973e5&"
import script from "./AddDependents.vue?vue&type=script&lang=js&"
export * from "./AddDependents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports